// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

.w3a-parent-container *,
.w3a-parent-container ::before,
.w3a-parent-container ::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

.w3a-parent-container ::before,
.w3a-parent-container ::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

.w3a-parent-container html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

.w3a-parent-container body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

.w3a-parent-container hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

.w3a-parent-container abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

.w3a-parent-container h1,
.w3a-parent-container h2,
.w3a-parent-container h3,
.w3a-parent-container h4,
.w3a-parent-container h5,
.w3a-parent-container h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

.w3a-parent-container a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

.w3a-parent-container b,
.w3a-parent-container strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

.w3a-parent-container code,
.w3a-parent-container kbd,
.w3a-parent-container samp,
.w3a-parent-container pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

.w3a-parent-container small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

.w3a-parent-container sub,
.w3a-parent-container sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

.w3a-parent-container sub {
  bottom: -0.25em;
}

.w3a-parent-container sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

.w3a-parent-container table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

.w3a-parent-container button,
.w3a-parent-container input,
.w3a-parent-container optgroup,
.w3a-parent-container select,
.w3a-parent-container textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

.w3a-parent-container button,
.w3a-parent-container select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

.w3a-parent-container button,
.w3a-parent-container [type='button'],
.w3a-parent-container [type='reset'],
.w3a-parent-container [type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

.w3a-parent-container :-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

.w3a-parent-container :-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

.w3a-parent-container progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

.w3a-parent-container ::-webkit-inner-spin-button,
.w3a-parent-container ::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

.w3a-parent-container [type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

.w3a-parent-container ::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

.w3a-parent-container ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

.w3a-parent-container summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

.w3a-parent-container blockquote,
.w3a-parent-container dl,
.w3a-parent-container dd,
.w3a-parent-container h1,
.w3a-parent-container h2,
.w3a-parent-container h3,
.w3a-parent-container h4,
.w3a-parent-container h5,
.w3a-parent-container h6,
.w3a-parent-container hr,
.w3a-parent-container figure,
.w3a-parent-container p,
.w3a-parent-container pre {
  margin: 0;
}

.w3a-parent-container fieldset {
  margin: 0;
  padding: 0;
}

.w3a-parent-container legend {
  padding: 0;
}

.w3a-parent-container ol,
.w3a-parent-container ul,
.w3a-parent-container menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
.w3a-parent-container dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

.w3a-parent-container textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

.w3a-parent-container input::placeholder,
.w3a-parent-container textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

.w3a-parent-container button,
.w3a-parent-container [role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
.w3a-parent-container :disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

.w3a-parent-container img,
.w3a-parent-container svg,
.w3a-parent-container video,
.w3a-parent-container canvas,
.w3a-parent-container audio,
.w3a-parent-container iframe,
.w3a-parent-container embed,
.w3a-parent-container object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

.w3a-parent-container img,
.w3a-parent-container video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
.w3a-parent-container [hidden] {
  display: none;
}

.w3a-parent-container *, .w3a-parent-container ::before, .w3a-parent-container ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.w3a-parent-container ::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.w3a-parent-container .container {
  width: 100%;
}
@media (min-width: 640px) {

  .w3a-parent-container .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .w3a-parent-container .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .w3a-parent-container .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .w3a-parent-container .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .w3a-parent-container .container {
    max-width: 1536px;
  }
}
.w3a-parent-container .visible {
  visibility: visible;
}
.w3a-parent-container .absolute {
  position: absolute;
}
.w3a-parent-container .relative {
  position: relative;
}
.w3a-parent-container .top-4 {
  top: 1rem;
}
.w3a-parent-container .z-20 {
  z-index: 20;
}
.w3a-parent-container .col-span-2 {
  grid-column: span 2 / span 2;
}
.w3a-parent-container .col-span-3 {
  grid-column: span 3 / span 3;
}
.w3a-parent-container .col-span-6 {
  grid-column: span 6 / span 6;
}
.w3a-parent-container .-mb-2 {
  margin-bottom: -0.5rem;
}
.w3a-parent-container .-ml-\\[100px\\] {
  margin-left: -100px;
}
.w3a-parent-container .mb-1 {
  margin-bottom: 0.25rem;
}
.w3a-parent-container .mb-4 {
  margin-bottom: 1rem;
}
.w3a-parent-container .mb-5 {
  margin-bottom: 1.25rem;
}
.w3a-parent-container .ml-2 {
  margin-left: 0.5rem;
}
.w3a-parent-container .ml-\\[3px\\] {
  margin-left: 3px;
}
.w3a-parent-container .mt-4 {
  margin-top: 1rem;
}
.w3a-parent-container .block {
  display: block;
}
.w3a-parent-container .flex {
  display: flex;
}
.w3a-parent-container .hidden {
  display: none;
}
.w3a-parent-container .h-12 {
  height: 3rem;
}
.w3a-parent-container .h-3 {
  height: 0.75rem;
}
.w3a-parent-container .w-3 {
  width: 0.75rem;
}
.w3a-parent-container .w-\\[300px\\] {
  width: 300px;
}
.w3a-parent-container .w-full {
  width: 100%;
}
.w3a-parent-container .rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.w3a-parent-container .cursor-pointer {
  cursor: pointer;
}
.w3a-parent-container .flex-col {
  flex-direction: column;
}
.w3a-parent-container .items-center {
  align-items: center;
}
.w3a-parent-container .rounded-md {
  border-radius: 0.375rem;
}
.w3a-parent-container .bg-app-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.w3a-parent-container .p-4 {
  padding: 1rem;
}
.w3a-parent-container .text-left {
  text-align: left;
}
.w3a-parent-container .text-right {
  text-align: right;
}
.w3a-parent-container .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.w3a-parent-container .font-medium {
  font-weight: 500;
}
.w3a-parent-container .leading-none {
  line-height: 1;
}
.w3a-parent-container .text-app-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.w3a-parent-container .text-app-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 25 40 / var(--tw-text-opacity));
}
.w3a-parent-container .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.w3a-parent-container .shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.w3a-parent-container .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.w3a-parent-container input[type="number"]::-webkit-inner-spin-button,
  .w3a-parent-container input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
          appearance: none;
}

/* cyrillic-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}

/* Modal */
.w3a-parent-container #w3a-modal {
  position: fixed;
  inset: 0px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-family: Inter;
}

.w3a-parent-container #w3a-modal.w3a-modal--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-modal__inner {
  position: relative;
  display: flex;
  max-height: 95%;
  min-height: 630px;
  width: 100%;
  max-width: 392px;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  border-radius: 32px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  opacity: 0;
  --tw-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__inner) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__inner {
  transform: scale(0);
  transition: all 150ms cubic-bezier(0.92, 0, 1, 0.67);
  transform-origin: center center;
}

.w3a-parent-container #w3a-modal .w3a-modal__inner.w3a-modal__inner--active {
  opacity: 1;
  transform: scale(1);
  transition: all 150ms cubic-bezier(0, 0.73, 0.71, 1);
  transform-origin: center center;
}

.w3a-parent-container #w3a-modal .w3a-modal__header {
  position: relative;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.w3a-parent-container #w3a-modal .w3a-modal__content {
  overflow-y: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.w3a-parent-container #w3a-modal .w3a-modal__footer {
  margin-top: auto;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__footer) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

/* Header */
.w3a-parent-container #w3a-modal .w3a-header {
  display: flex;
  align-items: center;
  padding-top: 2rem;
}
.w3a-parent-container #w3a-modal .w3a-header__logo {
  margin-bottom: 1rem;
}
.w3a-parent-container #w3a-modal .w3a-header__logo img {
  height: auto;
  width: 2.5rem;
}
.w3a-parent-container #w3a-modal .w3a-header__title {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(17 25 40 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-header__title) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal div.w3a-header__subtitle {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal div.w3a-header__subtitle) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal div.w3a-header__subtitle img {
  margin-left: 0.25rem;
  height: 14px;
  width: 14px;
}
.w3a-parent-container #w3a-modal button.w3a-header__button {
  position: absolute;
  top: 1.25rem;
  right: 1.75rem;
  cursor: pointer;
  border-width: 0px;
  padding: 0px;
}
.w3a-parent-container #w3a-modal button.w3a-header__button:focus {
  outline-color: #F9FAFB;
}
.w3a-parent-container #w3a-modal button.w3a-header__button:active {
  outline-color: #F9FAFB;
}
.w3a-parent-container :is(.dark #w3a-modal button.w3a-header__button:focus) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}
.w3a-parent-container :is(.dark #w3a-modal button.w3a-header__button:active) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

/* BODY */
.w3a-parent-container #w3a-modal div.w3a-social__policy {
  margin-top: 1rem;
  text-align: left;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal div.w3a-social__policy) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-group {
  margin-bottom: 1rem;
}
.w3a-parent-container #w3a-modal .w3a-group:last-child {
  margin-bottom: 0px;
}

.w3a-parent-container #w3a-modal .w3ajs-passwordless div.w3a-group__title {
  display: flex;
  align-items: center;
}

.w3a-parent-container #w3a-modal .w3ajs-passwordless div.w3a-group__title img {
  margin-left: 0.25rem;
  height: 14px;
  width: 14px;
}

.w3a-parent-container #w3a-modal .w3a-group.w3a-group--hidden,
.w3a-parent-container #w3a-modal .w3a-group.w3a-group--social-hidden,
.w3a-parent-container #w3a-modal .w3a-group.w3a-group--email-hidden,
.w3a-parent-container #w3a-modal .w3a-group.w3a-group--ext-wallet-hidden {
  display: none;
}

.w3a-parent-container #w3a-modal div.w3a-group__title {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(17 25 40 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal div.w3a-group__title) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

/* Adapter List */
.w3a-parent-container #w3a-modal ul.w3a-adapter-list {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  column-gap: 0.5rem;
  row-gap: 1rem;
  overflow-y: hidden;
  padding: 1px;
  max-height: 500px;
  transition: max-height 0.35s;
  transition-timing-function: cubic-bezier(0.92, 0, 0.74, 1);
}

.w3a-parent-container #w3a-modal ul.w3a-adapter-list.w3a-adapter-list--shrink {
  max-height: 108px;
  transition: max-height 0.3s;
  transition-timing-function: cubic-bezier(0, 0.73, 0.71, 1);
}

.w3a-parent-container #w3a-modal ul.w3a-adapter-list.w3a-adapter-list--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal li.w3a-adapter-item {
  list-style-type: none;
}

.w3a-parent-container #w3a-modal li.w3a-adapter-item--full {
  grid-column: span 6 / span 6;
}

.w3a-parent-container #w3a-modal .w3a-adapter-item--hide {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-external-toggle {
  display: block;
}

.w3a-parent-container #w3a-modal .w3a-external-toggle.w3a-external-toggle--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-external-container {
  margin-bottom: 0px;
  display: block;
}

.w3a-parent-container #w3a-modal .w3a-external-container.w3a-external-container--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-external-group {
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.w3a-parent-container #w3a-modal .w3a-external-group__left {
  flex-grow: 1;
}

.w3a-parent-container #w3a-modal button.w3a-external-back {
  margin-bottom: 0.5rem;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  border-width: 0px;
  background-image: none;
  padding: 0px;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal button.w3a-external-back:focus {
  outline-color: #F9FAFB;
}

.w3a-parent-container #w3a-modal button.w3a-external-back:active {
  outline-color: #F9FAFB;
}

.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back:focus) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

.w3a-parent-container :is(.dark #w3a-modal button.w3a-external-back:active) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

.w3a-parent-container #w3a-modal .w3a-external-back .w3a-group__title {
  margin-bottom: 0px;
  margin-left: 5px;
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-external-loader {
  display: flex;
  justify-content: center;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect {
  margin-bottom: 1rem;
  display: block;
  text-align: center;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect.w3a-wallet-connect--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__container {
  margin-left: auto;
  margin-right: auto;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 250px;
  border-radius: 10px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.625rem;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-wallet-connect__container) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-desktop,
.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-android {
  margin: auto;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-btn-group {
  display: flex;
  gap: 18px;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-ios {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.25rem;
  row-gap: 30px;
  padding: 0px;
  padding-bottom: 1.75rem;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr {
  margin: 1rem;
}
.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr > canvas,
.w3a-parent-container #w3a-modal .w3a-wallet-connect-qr > svg {
  margin: auto;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__container-android a {
  text-decoration-line: none;
}

.w3a-parent-container #w3a-modal .w3a-wallet-connect__logo > img {
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 1rem;
  width: 115px;
}

/* Footer Components */
.w3a-parent-container #w3a-modal .w3a-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-footer__links a:focus {
  outline-color: #F9FAFB;
}

.w3a-parent-container #w3a-modal .w3a-footer__links a:active {
  outline-color: #F9FAFB;
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-footer__links a:focus) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-footer__links a:active) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

.w3a-parent-container #w3a-modal .w3a-footer__links span {
  margin: 0 4px;
}

.w3a-parent-container #w3a-modal.w3a-modal--light .w3a-footer__links a:focus-visible {
  outline: 1px solid #0f1222;
}

.w3a-parent-container #w3a-modal.w3a-modal--light .w3a-external-back:focus-visible {
  outline: 1px solid #0f1222;
}

.w3a-parent-container .hover-icon {
  display: none;
  transition: display 150ms;
  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);
}

/* Text Field */
.w3a-parent-container #w3a-modal .w3a-text-field {
  margin-top: 0.5rem;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 25 40 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal .w3a-text-field::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity));
}
.w3a-parent-container #w3a-modal .w3a-text-field {
  outline-width: 0px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.w3a-parent-container #w3a-modal .w3a-text-field:focus {
  border-color: transparent;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 100 255 / var(--tw-ring-opacity));
}
.w3a-parent-container #w3a-modal .w3a-text-field:disabled {
  cursor: not-allowed;
}
.w3a-parent-container #w3a-modal .w3a-text-field:disabled::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field:focus) {
  border-color: transparent;
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 100 255 / var(--tw-ring-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-text-field:disabled)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity));
}
.w3a-parent-container #w3a-modal .w3a-text-field {

  line-height: 1.25em;
}

.w3a-parent-container #w3a-modal .w3a-text-field--country-code {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
}

.w3a-parent-container #w3a-modal .w3a-text-field--number {
  -webkit-appearance: none;
          appearance: none;
}

.w3a-parent-container #w3a-modal .w3a-sms-field--error {
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill,
.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:hover,
.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:focus,
.w3a-parent-container #w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:active {
  --tw-shadow: 0 0 0 30px #f9fafb inset;
  --tw-shadow-colored: inset 0 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  -webkit-text-fill-color: #111928 !important;
}
.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill,
.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:hover,
.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:focus,
.w3a-parent-container #w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:active {
  --tw-shadow: 0 0 0 30px #374151 inset;
  --tw-shadow-colored: inset 0 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  -webkit-text-fill-color: #fff !important;
}

/* Buttons */
.w3a-parent-container #w3a-modal .w3a-button {
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(17 25 40 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal .w3a-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.w3a-parent-container #w3a-modal .w3a-button:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
  outline-color: #F9FAFB;
}
.w3a-parent-container #w3a-modal .w3a-button:active {
  outline-color: #F9FAFB;
}
.w3a-parent-container #w3a-modal .w3a-button:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-button) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 25 40 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-button:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 42 55 / var(--tw-bg-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-button:focus) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 25 40 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-button:active) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-button:disabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 69 85 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-button--primary {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-button--primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-button--primary:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  outline-color: #A4CAFE;
}

.w3a-parent-container #w3a-modal .w3a-button--primary:active {
  outline-color: #A4CAFE;
}

.w3a-parent-container #w3a-modal .w3a-button--primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(235 245 255 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:focus) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-button--primary:disabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(45 72 116 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-button--login {
  display: inline-flex;
  height: 2.75rem;
  align-items: center;
  justify-content: center;
}

.w3a-parent-container #w3a-modal button.w3a-button--login:hover > .hover-icon {
  display: block;
  transition: display 150ms;
  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);
}

.w3a-parent-container #w3a-modal button.w3a-button--login:hover > .image-icon {
  display: none;
  transition: display 150ms;
  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);
}

.w3a-parent-container #w3a-modal button.w3a-button-expand {
  margin-top: 1rem;
  margin-left: auto;
  height: auto;
  width: auto;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(3 100 255 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal button.w3a-button-expand:hover {
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal button.w3a-button-expand:focus-visible {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #F9FAFB;
}

.w3a-parent-container :is(.dark #w3a-modal button.w3a-button-expand:hover) {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal button.w3a-button-expand:focus-visible) {
  outline-style: solid;
  outline-width: 1px;
  outline-color: #9CA3AF;
}

/* SMS */
.w3a-parent-container #w3a-modal .w3a-sms-field__container {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 0.5rem;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-selected {
  display: flex;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown {
  position: absolute;
  z-index: 10;
  height: 185px;
  width: 120px;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity));
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown {
  overflow-y: scroll;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown {
  transform: translate(0, -230px);
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown ul {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown ul) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li {
  cursor: pointer;
  padding: 0px;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-sms-field__code-dropdown li:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li button {
  height: 100%;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: left;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code-dropdown li button div {
  display: flex;
  align-items: center;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__code {
  grid-column: span 5 / span 5;
}

.w3a-parent-container #w3a-modal .w3a-sms-field__number {
  grid-column: span 7 / span 7;
}

/* SPINNER */
/* Loader */
.w3a-parent-container #w3a-modal .w3a-modal__loader {
  position: absolute;
  inset: 0px;
  z-index: 10;
  display: flex;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__loader.w3a-modal__loader--hidden {
  display: none;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-content {
  position: relative;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-info {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 30px;
  padding-right: 30px;
}

.w3a-parent-container #w3a-modal .w3a-spinner-label {
  margin-top: 10px;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(3 100 255 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-spinner-message {
  margin-top: 10px;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-spinner-message::first-letter {
  text-transform: capitalize;
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-spinner-message) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal .w3a-spinner-message.w3a-spinner-message--error {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-spinner-power {
  margin-top: auto;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(183 184 189 / var(--tw-text-opacity));
}
.w3a-parent-container #w3a-modal .w3a-spinner-power > img {
  display: inline;
  height: 2rem;
  width: auto;
}

.w3a-parent-container #w3a-modal .w3a-spinner {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
  display: inline-block;
  position: relative;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background: conic-gradient(transparent, #0364ff);
  animation: rotate 1s linear infinite;
}

.w3a-parent-container #w3a-modal .w3a-spinner__mask,
.w3a-parent-container #w3a-modal .w3a-spinner__head {
  content: "";
  position: absolute;
  border-radius: 100%;
}

.w3a-parent-container #w3a-modal .w3a-spinner__mask {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-spinner__mask) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-spinner__mask {
  width: 50px;
  height: 50px;
  top: 5px;
  left: 5px;
}

.w3a-parent-container #w3a-modal .w3a-spinner__head {
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
  height: 5px;
  width: 5px;
  top: 0;
  left: 26px;
}

@keyframes rotate {
  from {
    transform: rotateZ(0);
  }
  to {
    transform: rotateZ(360deg);
  }
}

/* Loader Bridge */
.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge-message {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-bridge-message::first-letter {
  text-transform: capitalize;
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-bridge-message) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo {
  display: flex;
  padding: 0.5rem;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo--default {
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(3 100 255 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-app-logo--default) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo img {
  height: auto;
  max-height: 72px;
  width: 72px;
  max-width: 72px;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-app-logo--default img {
  max-height: 45px;
  width: 45px;
  max-width: 45px;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-social-logo {
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark #w3a-modal .w3a-modal__loader-social-logo) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-social-logo img {
  height: 4rem;
  width: 4rem;
}

.w3a-parent-container #w3a-modal .w3a-modal__loader-adapter img {
  width: 84px;
  height: auto;
}

.w3a-parent-container #w3a-modal .w3a-modal__connector {
  display: flex;
  align-items: center;
}

.w3a-parent-container .w3a-modal__connector-beat {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.w3a-parent-container .w3a-modal__connector-beat div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #808080;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.w3a-parent-container .w3a-modal__connector-beat div:nth-child(1) {
  left: 8px;
  animation: beat1 2.4s infinite;
}

.w3a-parent-container .w3a-modal__connector-beat div:nth-child(2) {
  left: 8px;
  animation: beat2 2.4s infinite;
}

.w3a-parent-container .w3a-modal__connector-beat div:nth-child(3) {
  left: 8px;
  animation: beat3 2.4s infinite;
}

.w3a-parent-container .w3a-modal__connector-beat div:nth-child(4) {
  left: 32px;
  animation: beat4 2.4s infinite;
}

.w3a-parent-container .w3a-modal__connector-beat div:nth-child(5) {
  left: 56px;
  animation: beat5 2.4s infinite;
}

@keyframes beat1 {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(0);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(0);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes beat2 {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(1);
  }

  50% {
    transform: translate(24px, 0);
  }

  75% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(0, 0) scale(0);
  }
}

@keyframes beat3 {
  0% {
    transform: translate(0, 0);
  }

  25% {
    transform: translate(24px, 0);
  }

  50% {
    transform: translate(48px, 0);
  }

  75% {
    transform: translate(24px, 0);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes beat4 {
  0% {
    transform: translate(0, 0);
  }

  25% {
    transform: translate(24px, 0);
  }

  50% {
    transform: translate(24px, 0) scale(0);
  }

  75% {
    transform: translate(24px, 0) scale(1);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes beat5 {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0);
  }

  50% {
    transform: scale(0);
  }

  75% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.w3a-parent-container .group:hover .group-hover\\:flex {
  display: flex;
}

.w3a-parent-container :is(.dark .dark\\:bg-app-gray-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.w3a-parent-container :is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
`, "",{"version":3,"sources":["webpack://./../ui/css/web3auth.css","<no source>"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAKf;;EAAA,wBAAsB;UAAtB;AAAsB;;AAI1B,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,sFAAsF;AACxF;AACA,aAAa;AACb;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,oEAAoE;AACtE;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,gHAAgH;AAClH;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,mHAAmH;AACrH;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gHAAgH;EAChH;0BACwB;AAC1B;AACA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,sFAAsF;AACxF;AACA,aAAa;AACb;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,oEAAoE;AACtE;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,gHAAgH;AAClH;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,mHAAmH;AACrH;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gHAAgH;EAChH;0BACwB;AAC1B;AACA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,sFAAsF;AACxF;AACA,aAAa;AACb;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,oEAAoE;AACtE;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,gHAAgH;AAClH;AACA,cAAc;AACd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kHAAkH;EAClH,mHAAmH;AACrH;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gHAAgH;EAChH;0BACwB;AAC1B;;AAEA,UAAU;AAER;EAAA,eAA8E;EAA9E,UAA8E;EAA9E,sBAA8E;EAA9E,aAA8E;EAA9E,mBAA8E;EAA9E,uBAA8E;EAA9E,aAA8E;EAA9E;AAA8E;;AAI9E;EAAA;AAAa;;AAIb;EAAA,kBAgBwB;EAhBxB,aAgBwB;EAhBxB,eAgBwB;EAhBxB,iBAgBwB;EAhBxB,WAgBwB;EAhBxB,gBAgBwB;EAhBxB,sBAgBwB;EAhBxB,kBAgBwB;EAhBxB,kBAgBwB;EAhBxB,mBAgBwB;EAhBxB,iBAgBwB;EAhBxB,sBAgBwB;EAhBxB,yDAgBwB;EAhBxB,kBAgBwB;EAhBxB,yDAgBwB;EAhBxB,UAgBwB;EAhBxB,6CAgBwB;EAhBxB,wDAgBwB;EAhBxB;AAgBwB;;AAhBxB;EAAA,sBAgBwB;EAhBxB,sDAgBwB;EAhBxB,kBAgBwB;EAhBxB;AAgBwB;;AAjB1B;EAkBE,mBAAmB;EACnB,oDAAoD;EACpD,+BAA+B;AACjC;;AAGE;EAAA,UAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD;AAHkB;;AAOlB;EAAA,kBAAyB;EAAzB,kBAAyB;EAAzB,mBAAyB;EAAzB,mBAAyB;EAAzB;AAAyB;AAGzB;EAAA,gBAAgC;EAAhC,kBAAgC;EAAhC,mBAAgC;EAAhC,iBAAgC;EAAhC;AAAgC;AAGhC;EAAA,gBAAoG;EAApG,mBAAoG;EAApG,uBAAoG;EAApG,kBAAoG;EAApG,yDAAoG;EAApG,kBAAoG;EAApG,mBAAoG;EAApG,iBAAoG;EAApG,oBAAoG;EAApG;AAAoG;AAApG;EAAA,kBAAoG;EAApG;AAAoG;;AAGtG,WAAW;AAET;EAAA,aAA6B;EAA7B,mBAA6B;EAA7B;AAA6B;AAG7B;EAAA;AAAW;AAGX;EAAA,YAAkB;EAAlB;AAAkB;AAGlB;EAAA,kBAA0D;EAA1D,oBAA0D;EAA1D,gBAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AAA1D;EAAA,oBAA0D;EAA1D;AAA0D;AAG1D;EAAA,aAAqF;EAArF,mBAAqF;EAArF,mBAAqF;EAArF,oBAAqF;EAArF,gBAAqF;EAArF,oBAAqF;EAArF;AAAqF;AAArF;EAAA,oBAAqF;EAArF;AAAqF;AAGrF;EAAA,oBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA,kBAAiQ;EAAjQ,YAAiQ;EAAjQ,cAAiQ;EAAjQ,eAAiQ;EAAjQ,iBAAiQ;EAAjQ;AAAiQ;AAAjQ;EAAA;AAAiQ;AAAjQ;EAAA;AAAiQ;AAAjQ;EAAA,oBAAiQ;EAAjQ,kBAAiQ;EAAjQ;AAAiQ;AAAjQ;EAAA,oBAAiQ;EAAjQ,kBAAiQ;EAAjQ;AAAiQ;;AAGnQ,SAAS;AAEP;EAAA,gBAAkF;EAAlF,gBAAkF;EAAlF,kBAAkF;EAAlF,iBAAkF;EAAlF,gBAAkF;EAAlF,oBAAkF;EAAlF;AAAkF;AAAlF;EAAA,oBAAkF;EAAlF;AAAkF;;AAIlF;EAAA;AAAW;AAGX;EAAA;AAAW;;AAIX;EAAA,aAAwB;EAAxB;AAAwB;;AAIxB;EAAA,oBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;;AAO7B;;;;EAAA;AAAa;;AAIb;EAAA,qBAAiE;EAAjE,mBAAiE;EAAjE,oBAAiE;EAAjE,gBAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAAjE;EAAA,oBAAiE;EAAjE;AAAiE;;AAGnE,iBAAiB;AAEf;EAAA,aAAyD;EAAzD,gDAAyD;EAAzD,kBAAyD;EAAzD,aAAyD;EAAzD,kBAAyD;EACzD,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B;AAJyD;;AAO3D;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAGE;EAAA;AAAa;;AAIb;EAAA;AAAgB;;AAIhB;EAAA;AAAiB;;AAIjB;EAAA;AAAa;;AAIb;EAAA;AAAY;;AAIZ;EAAA;AAAa;;AAIb;EAAA,kBAAiB;EAAjB;AAAiB;;AAIjB;EAAA;AAAa;;AAIb;EAAA,mBAAgC;EAAhC,aAAgC;EAAhC,eAAgC;EAAhC;AAAgC;;AAIhC;EAAA;AAAgB;;AAIhB;EAAA,qBAAyT;EAAzT,oBAAyT;EAAzT,eAAyT;EAAzT,mBAAyT;EAAzT,iBAAyT;EAAzT,sBAAyT;EAAzT,YAAyT;EAAzT,oBAAyT;EAAzT;AAAyT;;AAAzT;EAAA;AAAyT;;AAAzT;EAAA;AAAyT;;AAAzT;EAAA,oBAAyT;EAAzT;AAAyT;;AAAzT;EAAA,oBAAyT;EAAzT,kBAAyT;EAAzT;AAAyT;;AAAzT;EAAA,oBAAyT;EAAzT,kBAAyT;EAAzT;AAAyT;;AAIzT;EAAA,kBAAsC;EAAtC,gBAAsC;EAAtC,oBAAsC;EAAtC;AAAsC;;AAItC;EAAA,aAA0B;EAA1B;AAA0B;;AAI1B;EAAA,mBAA6B;EAA7B,cAA6B;EAA7B;AAA6B;;AAI7B;EAAA;AAAa;;AAIb;EAAA,iBAAuH;EAAvH,kBAAuH;EAAvH,uBAAuH;EAAvH,kBAAuH;EAAvH,gBAAuH;EAAvH,mBAAuH;EAAvH,kBAAuH;EAAvH,yDAAuH;EAAvH,iBAAuH;EAAvH,oBAAuH;EAAvH,qBAAuH;EAAvH,sBAAuH;EAAvH,mBAAuH;EAAvH,oBAAuH;EAAvH;AAAuH;;AAAvH;EAAA,oBAAuH;EAAvH;AAAuH;;AAKvH;;EAAA;AAAa;;AAIb;EAAA,aAAsB;EAAtB;AAAsB;;AAItB;EAAA,sBAA8D;EAA9D,aAA8D;EAA9D,eAA8D;EAA9D,mBAA8D;EAA9D,aAA8D;EAA9D,YAA8D;EAA9D;AAA8D;;AAI9D;EAAA;AAAU;AAIV;;EAAA;AAAa;;AAIb;EAAA;AAAmB;;AAInB;EAAA,iBAAkC;EAAlC,kBAAkC;EAAlC,eAAkC;EAAlC,mBAAkC;EAAlC;AAAkC;;AAGpC,sBAAsB;AAEpB;EAAA,aAAiE;EAAjE,mBAAiE;EAAjE,uBAAiE;EAAjE,kBAAiE;EAAjE,iBAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA;AAA8M;;AAA9M;EAAA;AAA8M;;AAA9M;EAAA,oBAA8M;EAA9M,kBAA8M;EAA9M;AAA8M;;AAA9M;EAAA,oBAA8M;EAA9M,kBAA8M;EAA9M;AAA8M;;AAGhN;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA,eAAe;AAEb;EAAA,kBAwB6B;EAxB7B,qBAwB6B;EAxB7B,iBAwB6B;EAxB7B,sBAwB6B;EAxB7B,yDAwB6B;EAxB7B,kBAwB6B;EAxB7B,yDAwB6B;EAxB7B,oBAwB6B;EAxB7B,uBAwB6B;EAxB7B,oBAwB6B;EAxB7B,qBAwB6B;EAxB7B,mBAwB6B;EAxB7B,oBAwB6B;EAxB7B,oBAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,2BAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,kBAwB6B;EAxB7B,2GAwB6B;EAxB7B,yGAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,yBAwB6B;EAxB7B,2GAwB6B;EAxB7B,yGAwB6B;EAxB7B,4FAwB6B;EAxB7B,oBAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA;AAwB6B;AAxB7B;EAAA,2BAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,sBAwB6B;EAxB7B,yDAwB6B;EAxB7B,kBAwB6B;EAxB7B,sDAwB6B;EAxB7B,oBAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,2BAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,yBAwB6B;EAxB7B,oBAwB6B;EAxB7B;AAwB6B;AAxB7B;EAAA,2BAwB6B;EAxB7B;AAwB6B;AAzB/B;;EA2BE,mBAAmB;AACrB;;AAGE;EAAA,aAAuC;EAAvC,WAAuC;EAAvC,8BAAuC;EAAvC,kBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,wBAAsB;UAAtB;AAAsB;;AAItB;EAAA,mBAIM;EAJN,qBAIM;EAJN,qBAIM;EAJN,mBAIM;EAJN,oBAIM;EAJN,oBAIM;EAJN;AAIM;;AAON;;;;EAAA,qCAAsB;EAAtB,4DAAsB;EAAtB,uGAAsB;EACtB;AADsB;AAOtB;;;;EAAA,qCAA0B;EAA1B,4DAA0B;EAA1B,uGAA0B;EAC1B;AAD0B;;AAI5B,YAAY;AAEV;EAAA,qBA4BgC;EA5BhC,kBA4BgC;EA5BhC,yDA4BgC;EA5BhC,oBA4BgC;EA5BhC,uBA4BgC;EA5BhC,oBA4BgC;EA5BhC,qBA4BgC;EA5BhC,eA4BgC;EA5BhC,mBA4BgC;EA5BhC,gBA4BgC;EA5BhC,oBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC,yDA4BgC;EA5BhC,oBA4BgC;EA5BhC,6CA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC,yDA4BgC;EA5BhC,oBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC,sDA4BgC;EA5BhC,oBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC,sDA4BgC;EA5BhC,oBA4BgC;EA5BhC,gDA4BgC;EA5BhC,oBA4BgC;EA5BhC,kBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,oBA4BgC;EA5BhC,kBA4BgC;EA5BhC;AA4BgC;AA5BhC;EAAA,kBA4BgC;EA5BhC,sDA4BgC;EA5BhC,oBA4BgC;EA5BhC;AA4BgC;;AAIhC;EAAA,kBAa8B;EAb9B,uDAa8B;EAb9B,oBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B,uDAa8B;EAb9B,oBAa8B;EAb9B,gDAa8B;EAb9B;AAa8B;;AAb9B;EAAA;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B,yDAa8B;EAb9B,oBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B;AAa8B;;AAb9B;EAAA,kBAa8B;EAb9B,uDAa8B;EAb9B,oBAa8B;EAb9B;AAa8B;;AAI9B;EAAA,oBAAmD;EAAnD,eAAmD;EAAnD,mBAAmD;EAAnD;AAAmD;;AAGrD;EACE,cAAc;EACd,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6DAA6D;AAC/D;;AAGE;EAAA,gBAAyS;EAAzS,iBAAyS;EAAzS,YAAyS;EAAzS,WAAyS;EAAzS,mBAAyS;EAAzS,oBAAyS;EAAzS,oBAAyS;EAAzS;AAAyS;;AAAzS;EAAA,oBAAyS;EAAzS;AAAyS;;AAAzS;EAAA,oBAAyS;EAAzS,kBAAyS;EAAzS;AAAyS;;AAAzS;EAAA,oBAAyS;EAAzS;AAAyS;;AAAzS;EAAA,oBAAyS;EAAzS,kBAAyS;EAAzS;AAAyS;;AAG3S,QAAQ;AAEN;EAAA,aAA8B;EAA9B,iDAA8B;EAA9B;AAA8B;;AAI9B;EAAA;AAAW;;AAIX;EAAA,kBAAqI;EAArI,WAAqI;EAArI,aAAqI;EAArI;AAAqI;;AAArI;EAAA,wBAAqI;EAArI,kEAAqI;EAArI,2DAAqI;EAArI,sBAAqI;EAArI;AAAqI;;AAArI;EAAA,kBAAqI;EAArI,qBAAqI;EAArI,kBAAqI;EAArI,yDAAqI;EAArI,6CAAqI;EAArI,wDAAqI;EAArI;AAAqI;;AAArI;EAAA,kBAAqI;EAArI;AAAqI;;AADvI;EAEE,+BAA+B;AACjC;;AAGE;EAAA;AAAa;;AAIb;EAAA,mBAAoD;EAApD,sBAAoD;EAApD,mBAAoD;EAApD,oBAAoD;EAApD,oBAAoD;EAApD;AAAoD;;AAApD;EAAA,oBAAoD;EAApD;AAAoD;;AAIpD;EAAA,eAAwF;EAAxF;AAAwF;;AAAxF;EAAA,kBAAwF;EAAxF;AAAwF;;AAAxF;EAAA,kBAAwF;EAAxF,sDAAwF;EAAxF,oBAAwF;EAAxF;AAAwF;;AAIxF;EAAA,YAAwC;EAAxC,WAAwC;EAAxC,kBAAwC;EAAxC,mBAAwC;EAAxC,mBAAwC;EAAxC,sBAAwC;EAAxC;AAAwC;;AAIxC;EAAA,aAAwB;EAAxB;AAAwB;;AAIxB;EAAA;AAAiB;;AAIjB;EAAA;AAAiB;;AAGnB,YAAY;AACZ,WAAW;AAET;EAAA,kBAA8E;EAA9E,UAA8E;EAA9E,WAA8E;EAA9E,aAA8E;EAA9E,uBAA8E;EAA9E,kBAA8E;EAA9E;AAA8E;AAA9E;EAAA,kBAA8E;EAA9E;AAA8E;;AAI9E;EAAA;AAAa;;AAIb;EAAA,kBAIQ;EAJR,mBAIQ;EAJR,aAIQ;EAJR,sBAIQ;EAJR;AAIQ;;AAIR;EAAA,aAMS;EANT,YAMS;EANT,sBAMS;EANT,mBAMS;EANT,uBAMS;EANT,gBAMS;EANT,mBAMS;EANT,kBAMS;EANT;AAMS;;AAIT;EAAA,gBAGS;EAHT,eAGS;EAHT,mBAGS;EAHT,gBAGS;EAHT,oBAGS;EAHT;AAGS;;AAIT;EAAA,gBAAoF;EAApF,eAAoF;EAApF,mBAAoF;EAApF,oBAAoF;EAApF;AAAoF;;AAApF;EAAA;AAAoF;;AAApF;EAAA,oBAAoF;EAApF;AAAoF;AAGpF;EAAA,oBAAmB;EAAnB;AAAmB;;AAInB;EAAA,gBAEc;EAFd,kBAEc;EAFd,iBAEc;EAFd,oBAEc;EAFd;AAEc;AAGd;EAAA,eAAwB;EAAxB,YAAwB;EAAxB;AAAwB;;AAIxB;EAAA,kBAAyB;EAAzB,uDAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gDAAgD;EAChD;AAPyB;;AAU3B;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAGE;EAAA,kBAAoC;EAApC;AAAoC;;AAApC;EAAA,kBAAoC;EAApC;AAAoC;;AADtC;EAEE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAGE;EAAA,kBAAyB;EAAzB,uDAAyB;EACzB,WAAW;EACX,UAAU;EACV,MAAM;EACN;AAJyB;;AAO3B;EACE;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAEhB;EAAA,mBAAiD;EAAjD,aAAiD;EAAjD,mBAAiD;EAAjD;AAAiD;;AAIjD;EAAA,oBAAgE;EAAhE;AAAgE;;AAAhE;EAAA;AAAgE;;AAAhE;EAAA,oBAAgE;EAAhE;AAAgE;;AAIhE;EAAA,aAAe;EAAf;AAAe;;AAIf;EAAA,YAAwG;EAAxG,WAAwG;EAAxG,mBAAwG;EAAxG,uBAAwG;EAAxG,qBAAwG;EAAxG,kBAAwG;EAAxG;AAAwG;;AAAxG;EAAA,kBAAwG;EAAxG;AAAwG;;AAIxG;EAAA,YAAgD;EAAhD,gBAAgD;EAAhD,WAAgD;EAAhD;AAAgD;;AAIhD;EAAA,gBAAyC;EAAzC,WAAyC;EAAzC;AAAyC;;AAIzC;EAAA,aAA0G;EAA1G,YAA0G;EAA1G,WAA0G;EAA1G,mBAA0G;EAA1G,uBAA0G;EAA1G,qBAA0G;EAA1G,kBAA0G;EAA1G;AAA0G;;AAA1G;EAAA,kBAA0G;EAA1G;AAA0G;;AAI1G;EAAA,YAAgB;EAAhB;AAAgB;;AAGlB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAv4BA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer utilities {\n  input[type=\"number\"]::-webkit-inner-spin-button,\n  input[type=\"number\"]::-webkit-outer-spin-button {\n    @apply appearance-none;\n  }\n}\n\n/* cyrillic-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,\n    U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,\n    U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* greek-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format(\"woff2\");\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format(\"woff2\");\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,\n    U+2215, U+FEFF, U+FFFD;\n}\n\n/* Modal */\n#w3a-modal {\n  @apply box-border fixed inset-0 flex items-center justify-center p-4 font-body;\n}\n\n#w3a-modal.w3a-modal--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-modal__inner {\n  @apply flex\n  flex-col\n  w-full\n  max-w-[392px]\n  max-h-[95%]\n  min-h-[630px]\n  overflow-x-hidden\n  overflow-y-hidden\n  rounded-[32px]\n  opacity-0\n  relative\n  bg-white\n  dark:bg-app-gray-700\n  shadow-modal\n  border\n  border-app-gray-100\n  dark:border-app-gray-700;\n  transform: scale(0);\n  transition: all 150ms cubic-bezier(0.92, 0, 1, 0.67);\n  transform-origin: center center;\n}\n\n#w3a-modal .w3a-modal__inner.w3a-modal__inner--active {\n  @apply opacity-100;\n  transform: scale(1);\n  transition: all 150ms cubic-bezier(0, 0.73, 0.71, 1);\n  transform-origin: center center;\n}\n\n#w3a-modal .w3a-modal__header {\n  @apply relative px-8 py-2;\n}\n#w3a-modal .w3a-modal__content {\n  @apply px-8 py-4 overflow-y-auto;\n}\n#w3a-modal .w3a-modal__footer {\n  @apply items-center justify-center px-8 py-4 mt-auto text-center bg-app-gray-50 dark:bg-app-gray-600;\n}\n\n/* Header */\n#w3a-modal .w3a-header {\n  @apply flex items-center pt-8;\n}\n#w3a-modal .w3a-header__logo {\n  @apply mb-4;\n}\n#w3a-modal .w3a-header__logo img {\n  @apply w-10 h-auto;\n}\n#w3a-modal .w3a-header__title {\n  @apply text-xl font-bold text-app-gray-900 dark:text-white;\n}\n#w3a-modal div.w3a-header__subtitle {\n  @apply flex items-center text-sm font-normal text-app-gray-500 dark:text-app-gray-400;\n}\n#w3a-modal div.w3a-header__subtitle img {\n  @apply h-[14px] w-[14px] ml-1;\n}\n#w3a-modal button.w3a-header__button {\n  @apply absolute p-0 border-0 cursor-pointer top-5 right-7 focus:outline-app-gray-50 active:outline-app-gray-50 dark:focus:outline dark:focus:outline-1 dark:active:outline dark:active:outline-1 dark:focus:outline-app-gray-400 dark:active:outline-app-gray-400;\n}\n\n/* BODY */\n#w3a-modal div.w3a-social__policy {\n  @apply mt-4 text-xs font-medium text-left text-app-gray-500 dark:text-app-gray-400;\n}\n\n#w3a-modal .w3a-group {\n  @apply mb-4;\n}\n#w3a-modal .w3a-group:last-child {\n  @apply mb-0;\n}\n\n#w3a-modal .w3ajs-passwordless div.w3a-group__title {\n  @apply flex items-center;\n}\n\n#w3a-modal .w3ajs-passwordless div.w3a-group__title img {\n  @apply h-[14px] w-[14px] ml-1;\n}\n\n#w3a-modal .w3a-group.w3a-group--hidden,\n#w3a-modal .w3a-group.w3a-group--social-hidden,\n#w3a-modal .w3a-group.w3a-group--email-hidden,\n#w3a-modal .w3a-group.w3a-group--ext-wallet-hidden {\n  @apply hidden;\n}\n\n#w3a-modal div.w3a-group__title {\n  @apply mb-2 text-sm font-medium text-app-gray-900 dark:text-white;\n}\n\n/* Adapter List */\n#w3a-modal ul.w3a-adapter-list {\n  @apply grid grid-cols-6 overflow-y-hidden gap-x-2 gap-y-4;\n  padding: 1px;\n  max-height: 500px;\n  transition: max-height 0.35s;\n  transition-timing-function: cubic-bezier(0.92, 0, 0.74, 1);\n}\n\n#w3a-modal ul.w3a-adapter-list.w3a-adapter-list--shrink {\n  max-height: 108px;\n  transition: max-height 0.3s;\n  transition-timing-function: cubic-bezier(0, 0.73, 0.71, 1);\n}\n\n#w3a-modal ul.w3a-adapter-list.w3a-adapter-list--hidden {\n  @apply hidden;\n}\n\n#w3a-modal li.w3a-adapter-item {\n  @apply list-none;\n}\n\n#w3a-modal li.w3a-adapter-item--full {\n  @apply col-span-6;\n}\n\n#w3a-modal .w3a-adapter-item--hide {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-external-toggle {\n  @apply block;\n}\n\n#w3a-modal .w3a-external-toggle.w3a-external-toggle--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-external-container {\n  @apply block mb-0;\n}\n\n#w3a-modal .w3a-external-container.w3a-external-container--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-external-group {\n  @apply flex flex-wrap gap-3 mb-4;\n}\n\n#w3a-modal .w3a-external-group__left {\n  @apply flex-grow;\n}\n\n#w3a-modal button.w3a-external-back {\n  @apply inline-flex items-center p-0 mb-2 border-0 cursor-pointer bg-none text-app-gray-500 dark:text-app-gray-400 focus:outline-app-gray-50 active:outline-app-gray-50 dark:focus:outline dark:focus:outline-1 dark:active:outline dark:active:outline-1 dark:focus:outline-app-gray-400 dark:active:outline-app-gray-400;\n}\n\n#w3a-modal .w3a-external-back .w3a-group__title {\n  @apply text-app-gray-400 mb-0 ml-[5px];\n}\n\n#w3a-modal .w3a-external-loader {\n  @apply flex justify-center;\n}\n\n#w3a-modal .w3a-wallet-connect {\n  @apply block mb-4 text-center;\n}\n\n#w3a-modal .w3a-wallet-connect.w3a-wallet-connect--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-wallet-connect__container {\n  @apply bg-white rounded-[10px]  text-app-gray-500 dark:text-app-gray-400 text-xxs w-fit mx-auto min-w-[250px] py-4 px-3;\n}\n\n#w3a-modal .w3a-wallet-connect__container-desktop,\n#w3a-modal .w3a-wallet-connect__container-android {\n  @apply m-auto;\n}\n\n#w3a-modal .w3a-wallet-connect__container-btn-group {\n  @apply flex gap-[18px];\n}\n\n#w3a-modal .w3a-wallet-connect__container-ios {\n  @apply flex gap-x-5 gap-y-[30px] p-0 pb-7 box-border flex-wrap;\n}\n\n#w3a-modal .w3a-wallet-connect-qr {\n  @apply m-4;\n}\n#w3a-modal .w3a-wallet-connect-qr > canvas,\n#w3a-modal .w3a-wallet-connect-qr > svg {\n  @apply m-auto;\n}\n\n#w3a-modal .w3a-wallet-connect__container-android a {\n  @apply no-underline;\n}\n\n#w3a-modal .w3a-wallet-connect__logo > img {\n  @apply mt-0 mx-auto mb-4 w-[115px];\n}\n\n/* Footer Components */\n#w3a-modal .w3a-footer {\n  @apply flex items-center justify-center text-xs text-app-gray-400;\n}\n\n#w3a-modal .w3a-footer__links a {\n  @apply focus:outline-app-gray-50 active:outline-app-gray-50 dark:focus:outline dark:focus:outline-1 dark:active:outline dark:active:outline-1 dark:focus:outline-app-gray-400 dark:active:outline-app-gray-400;\n}\n\n#w3a-modal .w3a-footer__links span {\n  margin: 0 4px;\n}\n\n#w3a-modal.w3a-modal--light .w3a-footer__links a:focus-visible {\n  outline: 1px solid #0f1222;\n}\n\n#w3a-modal.w3a-modal--light .w3a-external-back:focus-visible {\n  outline: 1px solid #0f1222;\n}\n\n.hover-icon {\n  display: none;\n  transition: display 150ms;\n  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);\n}\n\n/* Text Field */\n#w3a-modal .w3a-text-field {\n  @apply py-3\n  px-6\n  mt-2\n  text-sm\n  outline-0\n  ring-0\n  border\n  rounded-full\n  placeholder-app-gray-500\n  dark:placeholder-app-gray-400\n  bg-app-gray-50\n  border-app-gray-300\n  text-app-gray-900\n  dark:bg-app-gray-600\n  dark:border-app-gray-500\n  dark:text-white\n  disabled:placeholder-app-gray-400\n  dark:disabled:placeholder-app-gray-500\n  disabled:cursor-not-allowed\n  focus:ring-1\n  focus:ring-app-primary-600\n  dark:focus:ring-app-primary-600\n\n  focus:border-transparent\n  dark:focus:border-transparent;\n\n  line-height: 1.25em;\n}\n\n#w3a-modal .w3a-text-field--country-code {\n  @apply flex justify-between w-full px-4;\n}\n\n#w3a-modal .w3a-text-field--number {\n  @apply appearance-none;\n}\n\n#w3a-modal .w3a-sms-field--error {\n  @apply text-red-500\n  text-sm\n  -mt-2\n  mb-2\n  ml-1.5;\n}\n\n#w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill,\n#w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:hover,\n#w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:focus,\n#w3a-container #w3a-modal input.w3a-text-field:-webkit-autofill:active {\n  @apply shadow-autofill;\n  -webkit-text-fill-color: #111928 !important;\n}\n#w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill,\n#w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:hover,\n#w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:focus,\n#w3a-container.dark #w3a-modal input.w3a-text-field:-webkit-autofill:active {\n  @apply shadow-autofillDark;\n  -webkit-text-fill-color: #fff !important;\n}\n\n/* Buttons */\n#w3a-modal .w3a-button {\n  @apply rounded-full\n  py-3 px-6\n  text-base\n  font-medium\n  /* background */\n  bg-app-gray-100\n  hover:bg-app-gray-300\n  focus:bg-app-gray-100\n  disabled:bg-app-gray-50\n  dark:bg-app-gray-900\n  dark:focus:bg-app-gray-900\n  dark:hover:bg-app-gray-800\n  dark:disabled:bg-[#3B4555]\n  /* text */\n  text-app-gray-900\n  focus:text-app-gray-700\n  disabled:text-app-gray-300\n  dark:text-white\n  dark:focus:text-white\n  dark:disabled:text-app-gray-500\n  /* outline */\n  focus:outline-app-gray-50\n  active:outline-app-gray-50\n  dark:focus:outline\n  dark:focus:outline-1\n  dark:active:outline\n  dark:active:outline-1\n  dark:focus:outline-app-gray-400\n  dark:active:outline-app-gray-400;\n}\n\n#w3a-modal .w3a-button--primary {\n  @apply bg-app-primary-600\n  hover:bg-app-primary-800\n  focus:bg-app-primary-600\n  dark:bg-app-primary-600\n  dark:hover:bg-app-primary-800\n  dark:focus:bg-app-primary-600\n  disabled:bg-app-primary-200\n  dark:disabled:bg-app-primary-950\n  text-white\n  focus:text-white\n  disabled:text-[#EBF5FF]\n  dark:disabled:text-app-gray-500\n  focus:outline-app-primary-300\n  active:outline-app-primary-300;\n}\n\n#w3a-modal .w3a-button--login {\n  @apply inline-flex items-center justify-center h-11;\n}\n\n#w3a-modal button.w3a-button--login:hover > .hover-icon {\n  display: block;\n  transition: display 150ms;\n  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);\n}\n\n#w3a-modal button.w3a-button--login:hover > .image-icon {\n  display: none;\n  transition: display 150ms;\n  transition-timing-function: cubic-bezier(0, 0.54, 0.63, 0.99);\n}\n\n#w3a-modal button.w3a-button-expand {\n  @apply w-auto h-auto mt-4 ml-auto text-sm text-app-primary-600 hover:text-app-primary-800 dark:hover:text-app-primary-500 focus-visible:outline-1 dark:focus-visible:outline-1 focus-visible:outline dark:focus-visible:outline focus-visible:outline-app-gray-50 dark:focus-visible:outline-app-gray-400;\n}\n\n/* SMS */\n#w3a-modal .w3a-sms-field__container {\n  @apply grid grid-cols-12 gap-2;\n}\n\n#w3a-modal .w3a-sms-field__code-selected {\n  @apply flex;\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown {\n  @apply absolute z-10 overflow-y-scroll bg-white divide-y divide-gray-100 rounded-lg shadow-modal dark:bg-gray-700 w-[120px] h-[185px];\n  transform: translate(0, -230px);\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown ul {\n  @apply py-2 text-sm text-gray-700 dark:text-gray-200;\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown li {\n  @apply p-0 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-900 dark:hover:text-white;\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown li button {\n  @apply w-full h-full px-4 py-2 text-left;\n}\n\n#w3a-modal .w3a-sms-field__code-dropdown li button div {\n  @apply flex items-center;\n}\n\n#w3a-modal .w3a-sms-field__code {\n  @apply col-span-5;\n}\n\n#w3a-modal .w3a-sms-field__number {\n  @apply col-span-7;\n}\n\n/* SPINNER */\n/* Loader */\n#w3a-modal .w3a-modal__loader {\n  @apply absolute inset-0 z-10 flex justify-center bg-white dark:bg-app-gray-700;\n}\n\n#w3a-modal .w3a-modal__loader.w3a-modal__loader--hidden {\n  @apply hidden;\n}\n\n#w3a-modal .w3a-modal__loader-content {\n  @apply text-center\n  mb-[50px]\n  relative\n  flex\n  flex-col;\n}\n\n#w3a-modal .w3a-modal__loader-info {\n  @apply flex\n  flex-grow\n  flex-col\n  justify-center\n  items-center\n  py-0\n  px-[30px];\n}\n\n#w3a-modal .w3a-spinner-label {\n  @apply text-base\n  font-medium\n  text-app-primary-600\n  mt-[10px];\n}\n\n#w3a-modal .w3a-spinner-message {\n  @apply mt-[10px] text-base text-app-gray-500 dark:text-white first-letter:capitalize;\n}\n#w3a-modal .w3a-spinner-message.w3a-spinner-message--error {\n  @apply text-red-500;\n}\n\n#w3a-modal .w3a-spinner-power {\n  @apply mt-auto\n  text-xs\n  text-[#b7b8bd];\n}\n#w3a-modal .w3a-spinner-power > img {\n  @apply inline w-auto h-8;\n}\n\n#w3a-modal .w3a-spinner {\n  @apply bg-app-primary-600;\n  display: inline-block;\n  position: relative;\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  background: conic-gradient(transparent, #0364ff);\n  animation: rotate 1s linear infinite;\n}\n\n#w3a-modal .w3a-spinner__mask,\n#w3a-modal .w3a-spinner__head {\n  content: \"\";\n  position: absolute;\n  border-radius: 100%;\n}\n\n#w3a-modal .w3a-spinner__mask {\n  @apply bg-white dark:bg-app-gray-700;\n  width: 50px;\n  height: 50px;\n  top: 5px;\n  left: 5px;\n}\n\n#w3a-modal .w3a-spinner__head {\n  @apply bg-app-primary-600;\n  height: 5px;\n  width: 5px;\n  top: 0;\n  left: 26px;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotateZ(0);\n  }\n  to {\n    transform: rotateZ(360deg);\n  }\n}\n\n/* Loader Bridge */\n#w3a-modal .w3a-modal__loader-bridge {\n  @apply flex mb-[14px] items-center justify-center;\n}\n\n#w3a-modal .w3a-modal__loader-bridge-message {\n  @apply text-app-gray-500 dark:text-white first-letter:capitalize;\n}\n\n#w3a-modal .w3a-modal__loader-app-logo {\n  @apply flex p-2;\n}\n\n#w3a-modal .w3a-modal__loader-app-logo--default {\n  @apply bg-app-primary-600 dark:bg-app-gray-50 w-[72px] h-[72px] rounded-full items-center justify-center;\n}\n\n#w3a-modal .w3a-modal__loader-app-logo img {\n  @apply max-h-[72px] max-w-[72px] w-[72px] h-auto;\n}\n\n#w3a-modal .w3a-modal__loader-app-logo--default img {\n  @apply max-h-[45px] max-w-[45px] w-[45px];\n}\n\n#w3a-modal .w3a-modal__loader-social-logo {\n  @apply bg-app-gray-100 dark:bg-app-gray-50 w-[72px] h-[72px] flex rounded-full items-center justify-center;\n}\n\n#w3a-modal .w3a-modal__loader-social-logo img {\n  @apply w-16 h-16;\n}\n\n#w3a-modal .w3a-modal__loader-adapter img {\n  width: 84px;\n  height: auto;\n}\n\n#w3a-modal .w3a-modal__connector {\n  display: flex;\n  align-items: center;\n}\n\n.w3a-modal__connector-beat {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.w3a-modal__connector-beat div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #808080;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n\n.w3a-modal__connector-beat div:nth-child(1) {\n  left: 8px;\n  animation: beat1 2.4s infinite;\n}\n\n.w3a-modal__connector-beat div:nth-child(2) {\n  left: 8px;\n  animation: beat2 2.4s infinite;\n}\n\n.w3a-modal__connector-beat div:nth-child(3) {\n  left: 8px;\n  animation: beat3 2.4s infinite;\n}\n\n.w3a-modal__connector-beat div:nth-child(4) {\n  left: 32px;\n  animation: beat4 2.4s infinite;\n}\n\n.w3a-modal__connector-beat div:nth-child(5) {\n  left: 56px;\n  animation: beat5 2.4s infinite;\n}\n\n@keyframes beat1 {\n  0% {\n    transform: scale(0);\n  }\n\n  25% {\n    transform: scale(0);\n  }\n\n  50% {\n    transform: scale(1);\n  }\n\n  75% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes beat2 {\n  0% {\n    transform: scale(0);\n  }\n\n  25% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: translate(24px, 0);\n  }\n\n  75% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(0, 0) scale(0);\n  }\n}\n\n@keyframes beat3 {\n  0% {\n    transform: translate(0, 0);\n  }\n\n  25% {\n    transform: translate(24px, 0);\n  }\n\n  50% {\n    transform: translate(48px, 0);\n  }\n\n  75% {\n    transform: translate(24px, 0);\n  }\n\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes beat4 {\n  0% {\n    transform: translate(0, 0);\n  }\n\n  25% {\n    transform: translate(24px, 0);\n  }\n\n  50% {\n    transform: translate(24px, 0) scale(0);\n  }\n\n  75% {\n    transform: translate(24px, 0) scale(1);\n  }\n\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes beat5 {\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(0);\n  }\n\n  50% {\n    transform: scale(0);\n  }\n\n  75% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
